module.exports = __webpack_public_path__ + "img/SDSN Youth Logo (1).08aa8095.png";